import { useToast } from 'primevue/usetoast';
import { router } from '@inertiajs/vue3';
import Swal from 'sweetalert2';
import { useI18n } from 'vue-i18n';
export function responseMessages() {
    const toast = useToast();
    const { t } = useI18n();
    function showResponseMessage(response, reload = true) {
        console.log(response);
        if (response.status === 200) {
            toast.add({
                severity: 'success',
                summary: t('Vorgang erfolgreich'),
                detail: response.data,
                life: 3000,
            });
            if (reload) {
                router.reload();
            }
        }
        else {
            toast.add({
                severity: 'error',
                summary: t('Fehler bei der Verarbeitung'),
                detail: response.data,
                life: 3000,
            });
        }
    }
    function showSuccessMessage(message) {
        toast.add({
            severity: 'success',
            summary: t('Vorgang erfolgreich'),
            detail: message,
            life: 3000,
        });
    }
    function showSuccessSwal(message) {
        Swal.fire({
            title: t('Vorgang erfolgreich'),
            text: message,
            icon: 'success',
            showConfirmButton: true,
            confirmButtonColor: "#528399",
            timer: 3000
        });
    }
    function showErrorMessage(message) {
        toast.add({
            severity: 'error',
            summary: t('Fehler bei der Verarbeitung'),
            detail: message,
            life: 3000,
        });
    }
    function showErrorSwal(message) {
        Swal.fire({
            title: t('Fehler bei der Verarbeitung'),
            text: message,
            icon: 'error',
            showConfirmButton: true,
            confirmButtonColor: "#528399",
            timer: 3000
        });
    }
    function showPageFlashMessage(page) {
        if (page.props != null && page.props.flash != null) {
            if (page.props.flash.success) {
                toast.add({
                    severity: 'success',
                    summary: t('Vorgang erfolgreich'),
                    detail: page.props.flash.success,
                    life: 3000,
                });
            }
            if (page.props.flash.error) {
                toast.add({
                    severity: 'error',
                    summary: t('Fehler bei der Verarbeitung'),
                    detail: page.props.flash.error,
                    life: 3000,
                });
            }
        }
        else {
            if (page.email) {
                toast.add({
                    severity: 'error',
                    summary: t('Fehler bei der Verarbeitung'),
                    detail: page.email,
                    life: 3000,
                });
            }
            if (page.description) {
                toast.add({
                    severity: 'error',
                    summary: t('Fehler bei der Verarbeitung'),
                    detail: page.description,
                    life: 3000,
                });
            }
            if (page.content) {
                toast.add({
                    severity: 'error',
                    summary: t('Fehler bei der Verarbeitung'),
                    detail: page.content,
                    life: 3000,
                });
            }
            if (page.category_id) {
                toast.add({
                    severity: 'error',
                    summary: t('Fehler bei der Verarbeitung'),
                    detail: page.category_id,
                    life: 3000,
                });
            }
            if (page.file) {
                toast.add({
                    severity: 'error',
                    summary: t('Fehler beim Datei-Upload'),
                    detail: page.file,
                    life: 3000,
                });
            }
        }
    }
    function showPageSwalMessage(page) {
        let icon = 'info';
        let title = t('Fehler bei der Verarbeitung');
        let text = '';
        if (page.props != null && page.props.flash != null) {
            if (page.props.flash.success) {
                icon = 'success';
                title = t('Vorgang erfolgreich');
                text = page.props.flash.success;
            }
            if (page.props.flash.error) {
                icon = 'error';
                title = t('Fehler bei der Verarbeitung');
                text = page.props.flash.error;
            }
        }
        else {
            icon = 'error';
            title = t('Fehler bei der Verarbeitung');
            if (page.email) {
                text = page.email;
            }
            if (page.description) {
                text = page.description;
            }
            if (page.content) {
                text = page.content;
            }
            if (page.category_id) {
                text = page.category_id;
            }
            if (page.file) {
                text = page.file;
            }
        }
        Swal.fire({
            title: title,
            text: text,
            icon: icon,
            showConfirmButton: true,
            confirmButtonColor: "#528399",
            timer: 3000
        });
    }
    return {
        showResponseMessage,
        showSuccessMessage,
        showSuccessSwal,
        showErrorMessage,
        showErrorSwal,
        showPageFlashMessage,
        showPageSwalMessage
    };
}
